export const environment = {
  production: false,
  clientId: 'patient_app',
  publicKey: 'TrPbi0xJT',
  homePath: '/main/home',
  baseApiUrl: '',
  authServiceUrl: 'https://api.prod-oralgenome.link',
  userServiceUrl: 'https://api.prod-oralgenome.link',
  wellnessServiceUrl: 'https://api.prod-oralgenome.link',
  logLevel: 5,
};
